define([
    'uiComponent',
    'jquery',
    'Lfi_Customer/js/model/state'
], (Component, $, customerState) => {
    'use strict';

    return Component.extend({
        defaults: {
            syncField: false
        },

        initialize: function (config, element) {
            this._super();

            if (!this.syncField) {
                return;
            }

            const input = $(element);
            input.val(customerState.getPersistentCustomerEmail());
            // And make sure to update storage with any new values
            input.on('change', function () {
                customerState.setPersistentCustomerEmail($(this).val());
            });
        }
    });
});
